import { VStack } from '@squire/ui';

import { styles } from './styles';
import type { CardProps } from './types';

const Card = ({ variant, children, style, ...props }: CardProps) => {
  styles.useVariants({ variant });

  return (
    <VStack style={[styles.container, style]} {...props}>
      {children}
    </VStack>
  );
};

Card.displayName = 'Card';
export { Card };
